// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"30009237","96":"227acce2","292":"1b8bda5a","390":"f32b2713","420":"e456f843","600":"be83bc69","655":"11eb2e5e","789":"2c866065","974":"0784fca1","994":"41b975e0"}[chunkId] + ".js";
};